<template>
  <div class="overflow-hidden">
    <div class="flex flex-row space-x-2 items-center w-full">
      <div class="flex items-center">
        <slot name="icon">No Icon</slot>
      </div>
      <div class="flex-1">
        <slot name="name">
          <h3 class="text-2xl font-bold text-gray-800 text-center">Activation Code</h3>
        </slot>
        <div class="text-sm text-gray-600 leading-4">
          <slot name="content" />
        </div>
      </div>
      <div class="">
        <m-button @click="handleAccess">Let's go</m-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'control-centre-item',
  props: {
    product: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleAccess() {
      this.$emit('access', this.product);
      this.$mixpanel.track('access-init', {
        location: 'Control Centre',
        product: this.product,
      });
    },
  },
};
</script>
